// src/cognito-config.js
const cognitoConfig = {
    region: 'us-east-1', // Your AWS region
    userPoolId: 'us-east-1_qKsrXJSBS', // Your Cognito User Pool ID
    clientId: '1t5h9lfrdf662ca5jvnnsb9etb', // Your Cognito App Client ID
};

export default cognitoConfig;